import { render } from "./Inicio.vue?vue&type=template&id=e06098a0"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"

import "./Inicio.vue?vue&type=style&index=0&id=e06098a0&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__